var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownBlue = function SvgArrowDownBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 9,
    viewBox: "0 0 16 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6692a6",
    d: "M7.635 8.365 1.188 1.918A1.05 1.05 0 1 1 2.673.432l5.705 5.706L14.082.433a1.05 1.05 0 0 1 1.485 1.485L9.12 8.365a1.046 1.046 0 0 1-1.485 0z"
  })));
};
export { SvgArrowDownBlue as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMTYgOSI+CiAgICA8cGF0aCBmaWxsPSIjNjY5MmE2IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik03LjYzNSA4LjM2NUwxLjE4OCAxLjkxOEExLjA1IDEuMDUgMCAxIDEgMi42NzMuNDMybDUuNzA1IDUuNzA2TDE0LjA4Mi40MzNhMS4wNSAxLjA1IDAgMCAxIDEuNDg1IDEuNDg1TDkuMTIgOC4zNjVhMS4wNDYgMS4wNDYgMCAwIDEtMS40ODUgMHoiLz4KPC9zdmc+Cg==";